module.exports = __webpack_public_path__ + "img/metbg.57e3f515.jpg";